// extracted by mini-css-extract-plugin
export default {"socialContainer":"SocialBtns_socialContainer__2Mlnr","socialLink":"SocialBtns_socialLink__a+Vwf"};